import React, { Component, useState, useEffect, useRef } from "react";
import parseDecimalNumber from "parse-decimal-number";
import { Icon, Input, Modal, Tooltip } from "antd";
import { AutoResizeTextArea } from "../../AutoResizeTextArea";

import { InputType, InputSize, LocalStorageKey } from "../../../models";
import {
  parseFormControlValue,
  formatNumber,
  fixDecimal,
  checkEmptyObject
} from "../../../services/utils";

import styles from "./styles.scss";
import { StaticHTML } from "../../StaticHTML";
import { getWindowWidth, isMobileScreen, localStorage } from "../../../services";
import { MileageWarning } from "./MileageWarning";

// Init parseDecimalNumber options on loading the script
const thousands = formatNumber(1000).slice(1, 2);
const decimal = thousands === "." ? "," : ".";
const autosizeOption = { minRows: 5, maxRows: 7 };
parseDecimalNumber.setOptions({ thousands, decimal });
const price = "price";
const power = "power";

const InputText = props => {
  const {
    title,
    isRequired,
    placeholder,
    unit,
    valueType,
    isDisabled,
    size,
    description,
    field,
    tooltip,
    inputTypeNumber,
    initiallyDisabled
  } = props;

  const isNumberType = () =>
    props.valueType === InputType.float || props.valueType === InputType.int;

  const getValueState = props => {
    const { value, field, defaultValue } = props;
    return {
      value: checkEmptyObject(value)
        ? isNumberType()
          ? formatNumber(value[field])
          : value[field]
        : defaultValue
    };
  };

  const [state, setState] = useState(getValueState(props));
  const [deferedValue, setDeferedValue] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (typeof deferedValue === "undefined") {
      return;
    } else if (deferedValue === "") {
      handleChange(deferedValue);
      return;
    } else {
      const timeOut = setTimeout(() => handleChange(deferedValue), 100);
      return () => clearTimeout(timeOut);
    }
  }, [deferedValue]);

  const prevValue = useRef(props.value);


  useEffect(() => {
    const { value, field, onChange } = props;

    if (prevValue.current != value) {
      if (
        !checkEmptyObject(value) ||
        !state.value ||
        !isNumberType() ||
        formatNumber(value[field]) !== state.value
      ) {
        setState(getValueState(props));
      }
    }
  }, [props]);

  const parseNumber = value => {
    if (props.valueType === InputType.float) {
      return fixDecimal(parseDecimalNumber(value), -2);
    }

    return parseInt(value, 10);
  };

  const deferedHandleChange = event => {
    setDeferedValue(event.target.value);
  };

  const handleChange = (deferedValue) => {
    const { onChange, field, valueType, multiValue } = props;
    let value = deferedValue;

    // TODO: Anastasija BUGFIX // if ((deferedValue && isNumberType()) || deferedValue === "" ) {
    if (deferedValue && isNumberType()) {
      // Remove thousands separator before parse the number, the deferedValue could be : 1,1111
      value = deferedValue.replace(new RegExp(`\\${thousands}`, "g"), "");
      value = parseNumber(value);

      let hasDecimal = false;
      let textValue = Number.isNaN(value)
        ? deferedValue.substring(0, deferedValue.length - 1)
        : formatNumber(value);

      // add missed decimal separator in case parseNumber removed it
      if (
        valueType === InputType.float &&
        deferedValue.length > 0 &&
        deferedValue.indexOf(decimal) === deferedValue.length - 1
      ) {
        textValue += decimal;
        hasDecimal = true;
      }

      setState({ value: textValue });
      setDeferedValue(textValue);
      if (!Number.isNaN(value) && !hasDecimal) {
        onChange(parseFormControlValue([field], [value]));
      }
    } else {
      if (multiValue) {
        let tempObj;
        if (parseFormControlValue([field], [value]) == undefined) {
          tempObj = {
            ...props.value,
            [field]: undefined
          };
        } else {
          tempObj = {
            ...props.value,
            ...parseFormControlValue([field], [value])
          };
        }

        onChange(tempObj);
      } else {
        if (value == "") {
          onChange({ [field]: undefined });
          onChange("");
        } else {
          onChange({ ...parseFormControlValue([field], [value]) });
        }
      }
    }
  };


  // @ts-ignore
  const value = deferedValue ? deferedValue : state.value;

  return (
    <React.Fragment>
      {!title ? null : (
        <span className={`control-title ${isRequired ? "required" : ""}`}>
          {title}
          {tooltip && (
            <Tooltip title={tooltip} placement="top">
              <Icon
                className={styles.infoIcon}
                type="info-circle-o"
              />
            </Tooltip>
          )}
        </span>
      )}

      {valueType === InputType.text ? (
        <React.Fragment>
          <AutoResizeTextArea
            value={value}
            placeholder={placeholder}
            onChange={deferedHandleChange}
            autoSize={autosizeOption}
            disabled={isDisabled}
          />
          {description ? (
            <div className={styles.info}>
              {"Savjeti za dobar opis oglasa"}
              <Icon className={styles.infoIcon} type="info-circle-o" onClick={() => setIsModalOpen(true)} />

              <Modal title="Savjeti za opis oglasa" visible={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} className={styles.modalDescription}>
                <pre className={styles.infoText}>
                  <StaticHTML content={description} />
                </pre>
              </Modal>
            </div>
          ) : null}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Input
            size={size}
            value={(field == price && value < 0) || (field == power && value == 0) ? "" : value}
            placeholder={placeholder}
            suffix={unit}
            onChange={deferedHandleChange}
            disabled={initiallyDisabled || isDisabled}
            // @ts-ignore
            inputMode={
              (valueType == InputType.string && "text") ||
              (valueType == InputType.float && "decimal") ||
              (inputTypeNumber && "decimal") ||
              (valueType != InputType.string && "numeric") ||
              (valueType != InputType.text && "numeric") ||
              (valueType != InputType.boolean && "numeric") ||
              (valueType != InputType.month && "numeric") ||
              (valueType != InputType.year && "numeric") ||
              (valueType != InputType.date && "numeric")
            }
          />
          {field === "mileage" && (
            <MileageWarning value={value} validationErrorIsShown={props["data-__field"].errors} />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

InputText.defaultProps = {
  placeholder: "Napišite nešto",
  unit: "",
  title: "",
  isRequired: false,
  valueType: "",
  isDisabled: false,
  size: InputSize.large,
  onChange: () => null,
  inputTypeNumber: false
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/FormControls/InputText/InputText.tsx